import { type Configuration, getAppConfiguration } from "./configuration";

let configurationPromise: Promise<Configuration> | null = null;

// getAppConfiguration is a server action, so every call from the browser costs a
// network round-trip. The configuration is derived from process.env only, so it
// cannot change while the page lives and the promise can be reused.
export function getCachedAppConfiguration(): Promise<Configuration> {
  if (!configurationPromise) {
    configurationPromise = getAppConfiguration().catch((error: unknown) => {
      // let a later call retry instead of caching the rejection forever
      configurationPromise = null;
      throw error;
    });
  }
  return configurationPromise;
}
